import isEmpty from 'lodash/isEmpty';
import { useId } from 'react';
import { BottomTooltip } from 'ui/tooltip';
import { DestructiveButton } from 'ui/button';
import { useDispatch, useSelector } from 'react-redux';
import { closeDeleteReportModal, deleteReportRequest } from 'modules/reportsManager';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import {
  selectOpenReportsTableModal,
  selectReportsTableConfig,
} from 'modules/reportsTable/selectors';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';

// type Props = {
//   deleteReportData: {
//     reportName: string,
//     reportId: number,
//   },
//   redirectOnComplete: boolean,
//   selectedReportIds: number[],
//   isOpen?: boolean,
//   onClose?: () => void,
// };

export const DeleteReportModal = ({
  deleteReportData,
  redirectOnComplete,
  selectedReportIds,
  isOpen = false,
  onClose,
}) => {
  const modalId = useId();
  const dispatch = useDispatch();
  const isDeleteReportModalOpen = useSelector(selectOpenReportsTableModal) || false;
  const canManageReports = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageReports,
  );
  const tableConfig = useSelector(selectReportsTableConfig);
  const deleteReports = () => {
    dispatch(
      deleteReportRequest({
        ids: !isEmpty(deleteReportData) ? [deleteReportData.reportId] : selectedReportIds,
        reportName: !isEmpty(deleteReportData)
          ? deleteReportData.reportName
          : `${selectedReportIds.length} reports`,
        filters: tableConfig,
        redirectOnComplete,
      }),
    );
    onClose?.();
  };

  const closeModal = onClose || (() => dispatch(closeDeleteReportModal()));

  return isOpen || isDeleteReportModalOpen ? (
    <Modal
      data-test="DeleteReportModal-componentType-modal"
      id={modalId}
      isModalOpen={isDeleteReportModalOpen}
      onClose={closeModal}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader data-test="DeleteReportModal-componentType-modal-header">
        Delete&nbsp;
        {selectedReportIds && selectedReportIds.length > 1 ? 'these reports?' : 'this report?'}
      </ModalHeader>
      <ModalBody data-test="DeleteReportModal-componentType-modal-content">
        Are you sure you want to permanently delete&nbsp;
        {deleteReportData.reportId
          ? // User clicked on trash icon within report row
            // Ignore any potentially selected reports
            `${deleteReportData.reportName}?`
          : // Multiple reports checked
            `${selectedReportIds && selectedReportIds.length} reports?`}
      </ModalBody>
      <ModalFooter onClose={closeModal}>
        <BottomTooltip
          isEnabled={!canManageReports}
          tooltipContent="You do not have permissions to create and manage reports. A project administrator could
          change this."
        >
          <DestructiveButton
            onClick={deleteReports}
            isDisabled={!canManageReports}
            data-test="DeleteReportModal-componentType-delete"
          >
            Delete
          </DestructiveButton>
        </BottomTooltip>
      </ModalFooter>
    </Modal>
  ) : null;
};
